import globals from "@lvt/globals";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import applyCaseMiddleware from "axios-case-converter";

import { CameraNavigation, Preset } from "@/store/userLists/types";


export const getPatrolState = async (camera_id: number): Promise<boolean> => {
    try {
        const request = applyCaseMiddleware(
            axios.create({
                baseURL: globals.userdashboard.proxyUrl,
                withCredentials: true,
            }),
        );

        const response = await request.get(`/api/cameras/suspend_patrol_state/${camera_id}`);

        return response.data.data;
    } catch (e) {
        throw e;
    }
};

export const fetchCameraData = createAsyncThunk(
    "fetchCameraData",
    async (cameraId: number): Promise<CameraNavigation[]> => {
        const client = applyCaseMiddleware(
            axios.create({
                baseURL: globals.userdashboard.proxyUrl,
                withCredentials: true,
            }),
        );
        const resp = await client.get(`/api/vms/cameras/nav/${cameraId}`);

        return resp.data.data;
    },
);

export const fetchCameraPresets = async (cameraId: number): Promise<Preset[]> => {
    const apiUrl = globals.userdashboard.proxyUrl;
    const presetReq = apiUrl + "/api/cameras/presets/" + cameraId.toString();
    const resp = await axios.get(presetReq, {
        withCredentials: true,
    });

    return resp.data.data;
};

export const fetchDownloadableImage = async (url: string): Promise<Blob> => {
    const resp = await axios.get(url, { withCredentials: false, responseType: "blob" });

    return resp.data;
};

export const requestQuickVideo = async (cameraIds: number[]) => {
    const url = `${globals.userdashboard.proxyUrl}/api/vms/history/quick_video`;
    const promises = cameraIds.map((id) => (
        axios.post(url, {
            camera_id: id,
            title: "Quick Video",
        }, {
            withCredentials: true,
        })
    ));

    await Promise.all(promises);

    return "ok";
};
